export class FilterPrices {
  minPrice;
  maxPrice;
  selectedPrices;
  constructor(data) {
    this.minPrice = data.minPrice;
    this.maxPrice = data.maxPrice;
    this.selectedPrices = data.selectedPrices?.map((p) => Number(p)) || [];
  }
  toJSON() {
    return { ...this };
  }
}
